export class WordUtil {
  static wordInflection(minOrderDay: number): string {
    let msg = '';
    if (!minOrderDay) {
      return '';
    }
    const lastDigit = minOrderDay % 10;
    switch (lastDigit) {
      case 0:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
        msg = 'дней';
        break;
      case 1:
        msg = 'день';
        break;
      case 2:
      case 3:
      case 4:
        msg = 'дня';
        break;
    }
    return msg;
  }
}
